/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BuyCreditsCommandDto interface.
 */
export function instanceOfBuyCreditsCommandDto(value) {
    if (!('creditPackageId' in value) || value['creditPackageId'] === undefined)
        return false;
    return true;
}
export function BuyCreditsCommandDtoFromJSON(json) {
    return BuyCreditsCommandDtoFromJSONTyped(json, false);
}
export function BuyCreditsCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'creditPackageId': json['creditPackageId'],
    };
}
export function BuyCreditsCommandDtoToJSON(json) {
    return BuyCreditsCommandDtoToJSONTyped(json, false);
}
export function BuyCreditsCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'creditPackageId': value['creditPackageId'],
    };
}
